import React, { useState } from "react";
import { ACCENTURE_LOGO_SRC, T, injectTheme, injectLandingTheme } from "../theme/theme";
import { auth_requestReset, auth_resetPassword } from "../API";

export default function ResetPasswordPage() {
  React.useEffect(() => { injectTheme(); injectLandingTheme(); }, []);

  const token = new URLSearchParams(window.location.search).get("token");

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [msg, setMsg]           = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  async function handleForgot(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await auth_requestReset(email);
      setMsg(
        "If that email is registered, a reset link has been logged to the server console."
      );
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  async function handleReset(e: React.FormEvent) {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true); setError("");
    try {
      await auth_resetPassword(token!, password, confirm);
      setMsg("Password updated. Redirecting to sign in…");
      setTimeout(() => (window.location.pathname = "/"), 2000);
    } catch (err: any) {
      setError(err?.response?.data?.detail || "Invalid or expired reset link");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="gwl-root" style={{ display: "flex", flexDirection: "column" }}>
      <header className="gw-app-header">
        <div className="gw-app-header-brand">
          <img src={ACCENTURE_LOGO_SRC} alt="Accenture" height={22} />
          <div className="gw-app-header-divider" />
          <div>
            <div className="gw-app-header-wordmark">Knowledge Suits</div>
            <div className="gw-app-header-sub">
              {'DMG Data Agents'}
            </div>
          </div>
        
        </div>
      </header>

      <div style={S.center}>
        <div style={S.card} className="gwl-hero-rise">
          <div style={S.cardHeader}>
            <div className="gwl-tile-idx">
              {token ? "Set new password" : "Reset password"}
            </div>
            <h2 style={{ margin: "12px 0 0", fontSize: 22, fontWeight: 400,
                         fontFamily: "'DM Serif Display', Georgia, serif", color: T.textPrimary }}>
              {token ? "Choose a new password" : "Forgot your password?"}
            </h2>
            <p style={{ margin: "8px 0 0", fontSize: 13, color: T.textMuted, fontWeight: 300 }}>
              {token
                ? "Enter a new password below. Minimum 8 characters."
                : "Enter your email and we'll send a reset link."}
            </p>
          </div>

          {msg && (
            <div style={S.ok}>
              <span style={{ marginRight: 8 }}>✓</span>{msg}
            </div>
          )}
          {error && (
            <div style={S.err}>
              <span style={{ marginRight: 8 }}>⚠</span>{error}
            </div>
          )}

          {!msg && !token && (
            <form onSubmit={handleForgot}>
              <div className="gw-form-group" style={{ marginBottom: 20 }}>
                <label className="gw-label">Email address</label>
                <input
                  className="gw-input"
                  type="email"
                  value={email}
                  placeholder="you@company.com"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button
                className="gw-btn gw-btn-primary"
                style={{ width: "100%", justifyContent: "center", padding: "11px 0" }}
                disabled={loading}
              >
                {loading ? "Sending…" : "Send reset link →"}
              </button>
            </form>
          )}

          {!msg && token && (
            <form onSubmit={handleReset}>
              <div className="gw-form-group" style={{ marginBottom: 14 }}>
                <label className="gw-label">New password</label>
                <input
                  className="gw-input"
                  type="password"
                  value={password}
                  placeholder="At least 8 characters"
                  minLength={8}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="gw-form-group" style={{ marginBottom: 20 }}>
                <label className="gw-label">Confirm password</label>
                <input
                  className="gw-input"
                  type="password"
                  value={confirm}
                  placeholder="Repeat new password"
                  minLength={8}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                />
              </div>
              <button
                className="gw-btn gw-btn-primary"
                style={{ width: "100%", justifyContent: "center", padding: "11px 0" }}
                disabled={loading}
              >
                {loading ? "Updating…" : "Update password →"}
              </button>
            </form>
          )}

          <div style={{ marginTop: 20, textAlign: "center" }}>
            <a href="/" style={{ fontSize: 12, color: T.brand, textDecoration: "none" }}>
              ← Back to sign in
            </a>
          </div>
        </div>
      </div>

      <footer className="gwl-footer">
        <div className="gwl-footer-txt">© 2025 Accenture · All rights reserved</div>
        <div className="gwl-footer-txt">Build 2025.06</div>
      </footer>
    </div>
  );
}

const S: Record<string, React.CSSProperties> = {
  center: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px",
  },
  card: {
    background: "#fff",
    border: "1px solid #c8d4e0",
    borderRadius: 16,
    padding: 36,
    width: 420,
    maxWidth: "95vw",
    boxShadow: "0 4px 24px rgba(30,58,110,.07)",
  },
  cardHeader: {
    marginBottom: 24,
    paddingBottom: 16,
    borderBottom: "1px solid #c8d4e0",
  },
  ok: {
    background: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: 8,
    padding: "10px 14px",
    color: "#166534",
    fontSize: 13,
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
  },
  err: {
    background: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: 8,
    padding: "10px 14px",
    color: "#991b1b",
    fontSize: 13,
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
  },
};